<template>
  <v-chip class="mb-2" close outlined @click:close="killChip">
    <span style="color: rgb(186, 151, 101); font-weight: bold;">{{ label }}</span>
    <v-text-field type="text" v-if="editing" :value="value" @change="emitValue" flat solo class="mt-8" @blur="editing=false"></v-text-field>
    <span v-else class="ml-2" @click="editing = true">{{ formatNumber(value) }}</span>
  </v-chip>
</template>

<script>
import numbro from 'numbro'
export default {
  data: function () {
    return {
      editing: false
    }
  },
  methods: {
    emitValue: function (newValue) {
      var value = newValue
      if (!isNaN(this.max) && value > this.max) {
        value = this.max
      } else if (!isNaN(this.min) && value < this.min) {
        value = this.min
      }
      this.$emit('input', value)
      this.editing = false
    },
    killChip: function () {
      this.$emit('kill')
    },
    formatNumber: function (value) {
      return numbro(value).format({
        thousandSeparated: true
      })
    }
  },
  props: {
    value: {},
    label: {
      type: String,
      required: true
    },
    max: {
      type: Number,
      required: false
    },
    min: {
      type: Number,
      required: false
    }
  }
}
</script>
